package org.hs_soft.runmynesto.pages.components.dialog.dialog

import androidx.compose.runtime.Composable
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.backgroundDialog
import org.hs_soft.runmynesto.domain.config.generalDialogSetting
import org.hs_soft.runmynesto.domain.config.overflowText
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.VectorIcon
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.hs_soft.runmynesto.pages.components.dialog.component.DialogTitle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px

@Composable
fun ErrorMsgDialog(
    description:String,
    windowSizeMode: WindowSizeModeEnum,
    onDismissDialog:()->Unit,
)
{
    Box(
        modifier = Modifier
            .position(Position.Absolute)
            .zIndex(Constants.ZIndex.largestZIndex)
            .top(0.px)
            .left(0.px)
            .right(0.px)
            .bottom(0.px)
            .fillMaxSize()
            .onClick {
               onDismissDialog()
            }
    ){
        Row(
            modifier = Modifier
                .align(Alignment.TopEnd)
                .margin(
                    Dimen.largePadding
                )
                .minWidth(Dimen.errorDialogWidth)
                .maxWidth(Dimen.errorDialogMaxWidth)
                .thenIf(
                    windowSizeMode==WindowSizeModeEnum.PHONE,
                    Modifier.fillMaxWidth()
                )
                .height(Dimen.errorDialogHeight)
                .overflowText()
                .padding(
                    topBottom = Dimen.semiNormalPadding,
                    leftRight = Dimen.largePadding
                )
                .backgroundColor(Theme.ErrorDialogColor.rgb)
                .borderRadius(Dimen.semiSmallBorderRadius)
                .onClick {
                    event: SyntheticMouseEvent -> event.stopPropagation()
                },
            verticalAlignment = Alignment.Top
        )
        {

            VectorIcon(
                modifier = Modifier
                    .margin( 
                        right = Dimen.mediumPadding,
                    ),
                pathData = Res.PathIcon.error,
                color = Theme.ErrorMain.hex,
                width =Dimen.semiMediumIconSize ,
                height = Dimen.semiMediumIconSize
            )

            Column(
                modifier = Modifier
                    .overflowText()
                    .fillMaxWidth(),

            )
            {
                SpanText(
                    text = Strings.current().error,
                    modifier = Modifier
                        .fontSize(FontSizes.semiLargeFontSize)
                        .fontFamily(FontFamily.Jakarta)
                        .fontWeight(FontWeight.Medium)
                        .overflowText()
                        .color(Theme.ErrorText.rgb)
                )

                SpanText(
                    text =description,
                    modifier = Modifier
                        .fontSize(FontSizes.mediumFontSize)
                        .fontFamily(FontFamily.Jakarta)
                        .color(Theme.ErrorText.rgb)
                        .fontWeight(FontWeight.Normal)
                        .overflowText()
                )
            }


        }

    }







}